<template> <!-- we can use functional component -->
  <div>
    <div class="wrapper wrapper-content animated fadeInRight">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-title">
          <h4 v-if="customer">
            Tokens for customer <span class="customerName">{{customer.name}}</span>:
          </h4>
				</div>
				<div class="ibox-content" v-if="item">
					<div class="row">
						<div class="enswitch-form-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div class="row form-group">
								<h4 class="group-header">
									Call center
									<i v-if="!item.callcenter" class="tokens-icon far fa-times-circle"></i>
									<i v-if="item.callcenter" class="tokens-icon far fa-check-circle"></i>
								</h4>
							</div>
							<div v-if="item.callcenter" class="row form-group">
								<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Token:</span>
								<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
									<input name="callcenter-token" caption="call center token" readonly v-model="item.callcenter.token" type="text" />
								</div>
							</div>

							<div v-if="!item.callcenter" class="row submit-button-container">
								<button @click="createCallcenterToken()" :disabled="sendCallcenterInProgress" ref="createcallcenterbtn" class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt" data-style="zoom-out" data-spinner-size="24" data-size="s" data-spinner-color="white" style="display: block;">
									<span class="ladda-label">Create call center token</span>
									<span class="fas fa-spinner fa-pulse"></span>
									<div class="ladda-progress" style="width: 0px"></div>
								</button>
							</div>

							<hr>

							<div class="row form-group">
								<h4 class="group-header">
									Recordings
									<i v-if="!item.recordings" class="tokens-icon far fa-times-circle"></i>
									<i v-if="item.recordings" class="tokens-icon far fa-check-circle"></i>
								</h4>
							</div>
							<div v-if="item.recordings">
								<div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Token:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
										<input name="name" caption="name" readonly v-model="item.recordings.token" type="text" />
									</div>
								</div>

								<div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">User name:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
										<input name="recordings-username" caption="recordings-username" v-model="item.recordings.username" type="text" />
									</div>
								</div>
							</div>

							<div v-if="!item.recordings" class="row submit-button-container">
								<button @click="createRecordingsToken()" :disabled="sendRecordingsInProgress" ref="createrecordingsbtn" class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt" data-style="zoom-out" data-spinner-size="24" data-size="s" data-spinner-color="white" style="display: block;">
									<span class="ladda-label">Create recordings token</span>
									<span class="fas fa-spinner fa-pulse"></span>
									<div class="ladda-progress" style="width: 0px"></div>
								</button>
							</div>

								<!-- <div class="row submit-button-container">
									<button type="submit" :disabled="sendInProgress" ref="submitbtn" class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt" data-style="zoom-out" data-spinner-size="24" data-size="s" data-spinner-color="white" style="display: block;">
										<span class="ladda-label">Save</span>
										<span class="fas fa-spinner fa-pulse"></span>
										<div class="ladda-progress" style="width: 0px"></div>

									</button>
								</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
  </div>
</template>

<script>
import {CustomerTokensService} from "../../services/CustomerTokensService";

export default {
	props: [],
	components: {},
	data: () => ({loading: false, customerId: null, customer: null, item: null, sendRecordingsInProgress: false, sendCallcenterInProgress: false}),
	created() {
		const $injector = this.$root.angularInjector;
		const $stateParams = $injector.get("$stateParams");

		const CoreApiService = $injector.get("CoreApiService");
		this.customersApiService = $injector.get("CustomersApiService");
		this.customerTokensService = new CustomerTokensService(CoreApiService);

		this.customerId = $stateParams.id;

		// this.customUrlsService = new CustomUrlsService(CoreApiService);

		this.SwalService = $injector.get("SwalService");
		this.loadCustomer();
		this.loadItemToEdit();
	},
	async mounted() {
		let promises = [];
		this.loading = true;
		if (!this.isNew) {
			// let phones = await this.phonesService.getPhonesList();
			promises.push(this.loadItemToEdit());
		}
		// else {
		// 	promises.push(this.loadPeopleList())
		// }
		// promises.push(this.loadPhones());
		await Promise.all(promises);
		this.loading = false;
	},
	watch: {
		sendCallcenterInProgress: function(val) {
			if (val) {
				this.$refs.createcallcenterbtn.dataset.loading = "";
			}
			else {
				delete this.$refs.createcallcenterbtn.dataset.loading;
			}
		},
		sendRecordingsInProgress: function(val) {
			if (val) {
				this.$refs.createrecordingsbtn.dataset.loading = "";
			}
			else {
				delete this.$refs.createrecordingsbtn.dataset.loading;
			}
		}
	},
	methods: {
		loadItemToEdit() {
			this.customerTokensService.get(this.customerId)
				.then(tokens => {
					this.item = tokens;
				})
				.catch(err => {
					console.error("Failed to fetch tokens for customer", err);
				});
			// this.sourceItem = await this.customUrlsService.get(this.id);
			// this.item = Object.assign({}, this.sourceItem);
			// delete this.item.id;
		},
		loadCustomer() {
			this.customersApiService.getCustomer({id: this.customerId})
				.then(response => {
					this.customer = response.data;
				})
				.catch(err => {
					console.error("Failed to fetch tokens for customer", err);
				});
			// this.sourceItem = await this.customUrlsService.get(this.id);
			// this.item = Object.assign({}, this.sourceItem);
			// delete this.item.id;
		},
		async createRecordingsToken() {
			this.sendRecordingsInProgress = true;
			try {
				await this.customerTokensService.createRecordingsToken(this.customerId);

				this.SwalService.popup({
					title: "Success!"
				}).then(f => {
					this.loadItemToEdit();

					// this.$router.replace("/list");
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: getErrorMessage(e), type: "error"
				});
			}
			finally {
				this.sendRecordingsInProgress = false;
			}
		},
		async createCallcenterToken() {
			this.sendCallcenterInProgress = true;
			try {
				await this.customerTokensService.createCallcenterToken(this.customerId);

				this.SwalService.popup({
					title: "Success!"
				}).then(f => {
					this.loadItemToEdit();
					// this.$router.replace("/list");
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: getErrorMessage(e), type: "error"
				});
			}
			finally {
				this.sendCallcenterInProgress = false;
			}
		}
	},
	computed: {

	}
};

function getErrorMessage(e) {
	if (e.message === "Bad request") {
		if (e.key === "error_username_in_use") {
			return "Duplicate username";
		}
		else if (e.key === "error_email_exists") {
			return "Duplicate email";
		}
	}
	return e.message || e.statusText || e || "Error";
}
</script>

<style lang="scss" scoped>
.group-header {
	text-align: center;
}
.customerName {
	text-decoration: underline;
}
.tokens-icon {
	font-size: 1.5em;
	&.fa-times-circle {
		color: rgb(255, 42, 42);
	}
	&.fa-check-circle {
		color: rgb(0, 212, 11);
	}
}
</style>
